<app-webhook-log
    [config]="config$ | async"
    [webhooks]="webhooks$ | async"
    [loading]="loading$ | async"
    [error]="error$ | async"
    [toggleWebhooksLoading]="toggleWebhooksLoading$ | async"
    (activeToggled)="onIsActiveToggled($event)">
</app-webhook-log>
